import { createSlice } from "@reduxjs/toolkit";
import { getEnrollInHealthPackageById, updateEnrollInHealthPackageById, deleteEnrollInHealthPackage,createEnrollInHealthPackage,getAllEnrollInHealthPackages } from "../../API/FormsData/EnrollInHealthPackage";

const initialState = {
    getallenrollInHealthPackages: [],
    loading: false,
    error: null,
    totalPages: 0,
    currentPage: 1,
};

const enrollInHealthPackageSlice = createSlice({
  name: "EnrollInHealthPackage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEnrollInHealthPackageById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEnrollInHealthPackageById.fulfilled, (state, action) => {
        state.loading = false;
        state.getallenrollInHealthPackages = [action.payload]; // Flat enrollInHealthPackage object array
        state.error = null;
      })
      .addCase(getEnrollInHealthPackageById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateEnrollInHealthPackageById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateEnrollInHealthPackageById.fulfilled, (state, action) => {
        state.loading = false;
        state.updateEnrollInHealthPackage = [action.payload]; // Flat enrollInHealthPackage object array
        state.error = null;
      })
      .addCase(updateEnrollInHealthPackageById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteEnrollInHealthPackage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteEnrollInHealthPackage.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteEnrollInHealthPackage = [action.payload]; // Flat enrollInHealthPackage object array
        state.error = null;
      })
      .addCase(deleteEnrollInHealthPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllEnrollInHealthPackages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllEnrollInHealthPackages.fulfilled, (state, action) => {
        state.loading = false;
        state.getallenrollInHealthPackages = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(getAllEnrollInHealthPackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createEnrollInHealthPackage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createEnrollInHealthPackage.fulfilled, (state, action) => {
        state.loading = false;
        state.createEnrollInHealthPackage = [action.payload]; // Flat enrollInHealthPackage object array
        state.error = null;
      })
      .addCase(createEnrollInHealthPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default enrollInHealthPackageSlice.reducer;